module.exports = __webpack_public_path__ + "img/pause.bc698159.svg";